module.exports = __webpack_public_path__ + "img/Number=37.576dd2f3.png";